import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import ContractInfoCard from "./ContractInfoCard";
import { useAppTranslation } from "../../i18n/useAppTranslation";
import DepositCard from "./DepositCard";
import DisabledTransactionCard from "./DisabledTransactionCard";
import WalletAddressBox from "./WalletAddressBox";

type Props = {};

const ProfilePage = (props: Props) => {
  const { t } = useAppTranslation("common");
  useEffect(() => {
    setTimeout(() => {
      const hash = window.location.hash;
      if (hash) {
        const element = document.querySelector(hash);
        if (element) element.scrollIntoView();
      }
    }, 1000);
  }, []);

  return (
    <RowStyled>
      <Helmet>
        <title key={"title"}>{t("common:meta.profileTitle")}</title>
      </Helmet>
      <Col>
        <Row>
          <WalletAddressBox />
          <ContractInfoCard />
        </Row>
        <Row>
          <DepositCard />
          <DisabledTransactionCard title="Withdraw" direction="right" />
        </Row>
      </Col>
    </RowStyled>
  );
};

const RowStyled = styled(Row)`
  & {
    input[type="number"]::-webkit-outer-spin-button,
    input[type="number"]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    input[type="number"] {
      -moz-appearance: textfield;
    }
  }
`;

export default ProfilePage;
